import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('pricing', {
        template: require('./pricing.html'),
        controller: PricingPageCtrl,
        controllerAs: 'vm'
    });

    PricingPageCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function PricingPageCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.mainBackground = require('Images/background.png');
        vm.logo = require('Images/nav-logo.png');

        vm.img_change_schedule = require('Images/SSP/change_schedule.png');
        vm.img_clock = require('Images/SSP/clock.png');
        vm.img_semester = require('Images/SSP/semester.png');
        vm.img_regular = require('Images/SSP/regular.png');
        vm.img_calculator = require('Images/SSP/calculator.png');
        vm.img_tuition_info = require('Images/SSP/tuition_info.png');


        vm.update_text = function() {
            let base_tuition = vm.to_days() >= 5 ? 8000 : 9000;

            if (vm.data.regular === 'Regular') {
                base_tuition -= 1000;
            } 
            
            let tuition =
                ((((4 * vm.data.minutes) / 60) *
                    base_tuition *
                    vm.to_days())) *
                vm.data.semesters;

            if (vm.data.semesters >= 3) {
                tuition -= 1000 * vm.data.semesters;
            }

            if (
                parseInt(vm.data.minutes) === 30 &&
                vm.to_days() >= 5
            ) {
                tuition -= 1000;
            }

            if (
                (parseInt(vm.data.minutes) === 45 ||
                    parseInt(vm.data.minutes) === 60) &&
                vm.to_days() >= 5
            ) {
                tuition -= 7000 * vm.data.semesters;
            }

            vm.tuition = tuition;
        }

        vm.to_days = ()=>{
            return parseInt(vm.data.days);
        }

        vm.data = {
            // days: 1,
            // minutes: 15,
            // semesters: 1,
            // regular: 'Regular'
        }

        //days, semesters, duration, regOrIrreg
        
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/pricing/pricing.component.js